import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { applyStyle } from '../../shape/utils';
import { select } from '../../utils/selection';
import { Advance } from './advance';
/**
 * @todo autoRotate when in polar coordinate
 */
export var Text = function Text(options, context) {
  var coordinate = context.coordinate;
  return function (points, value, defaults) {
    var color = value.color,
      _value$text = value.text,
      text = _value$text === void 0 ? '' : _value$text,
      fontSize = value.fontSize,
      _value$rotate = value.rotate,
      rotate = _value$rotate === void 0 ? 0 : _value$rotate,
      _value$transform = value.transform,
      transform = _value$transform === void 0 ? '' : _value$transform;
    var textStyle = {
      text: String(text),
      stroke: color,
      fill: color,
      fontSize: fontSize
    };
    var _points = _slicedToArray(points, 1),
      _points$ = _slicedToArray(_points[0], 2),
      x0 = _points$[0],
      y0 = _points$[1];
    return select(new Advance()).style('x', x0).style('y', y0).call(applyStyle, defaults).style('transform', "".concat(transform, "rotate(").concat(+rotate, ")")).style('coordCenter', coordinate.getCenter()).call(applyStyle, textStyle).call(applyStyle, options).node();
  };
};
Text.props = {
  defaultMarker: 'point',
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};